import toast from "react-hot-toast";
import axios from "axios";
import { callGetApi, callPostApi } from "../../../api/ApiCaller";
import { Get_Reward_Point_And_Wallet_Balance, Post_Complete_Post_PaidOrder } from "../../../api/ApiConst";
import { NO_ERROR } from "../../../api/constants";
import { SET_RESTAURANT_ID, setOrderType } from "../../../reducer/actions/utilityActions";
import { DINE_IN, HOME_DELIVERY, ORDER_PLACED, TAKE_AWAY } from "../../../translations/en/en";
import * as Storage from "../../../utils/GetSetStorage";
import { clearDineInSession } from "../../../utils/DineInSession";
import * as AirBridgeUtilities from "../../airbridge/AirBridgeUtilities";
import { InformationAlert } from "../../common/InformationAlert";
import { Fragment } from "react";

export const getItemTotalAmount = (items) => {
    const total = items.reduce((accumulator, currentValue) => accumulator + currentValue.finalPrice * currentValue.quantity, 0);
    return total;
};

export const getDealCartTotal = () => {
    let dealCart = Storage.getDealCart();
    if (!dealCart || dealCart.length === 0) {
        return 0;
    }

    return Storage.getDealCart().reduce((accumulator, currentItem) => accumulator + currentItem.itemPrice * currentItem.stealDealItemQty, 0);
};

export const checkAvailableNearByOrderType = (restaurantList, dispatchUtility, currentRestaurantId) => {
    // If a restaurant is already selected and exists in the list, keep it
    if (currentRestaurantId) {
        const existsInList = restaurantList.find((rest) => rest.restaurantUuid === currentRestaurantId);
        if (existsInList) {
            return;
        }
    }

    // TO check if nearby Order type is available
    const _restaurantList = restaurantList;
    let isDineInAvailable = false;
    let isDeliveryAvailable = false;
    let isTakeAwayAvailable = false;
    let selectedRestaurantObj = "";

    for (const rest of _restaurantList) {
        const { distanceInMeter, availableInDineIn, availableInHomeDelivery, availableInTakeAway } = rest;
        if (availableInDineIn) {
            isDineInAvailable = true;
            isTakeAwayAvailable = false;
            isDeliveryAvailable = false;
            selectedRestaurantObj = rest;
            break;
        } else if (availableInTakeAway) {
            isDineInAvailable = false;
            isDeliveryAvailable = false;
            isTakeAwayAvailable = true;
            selectedRestaurantObj = rest;
            break;
        } else if (availableInHomeDelivery) {
            isDineInAvailable = false;
            isTakeAwayAvailable = false;
            isDeliveryAvailable = true;
            selectedRestaurantObj = rest;
            break;
        }
    }
    // for (let i = 0; i < _restaurantList.length; i++) {
    //     const { distanceInMeter, availableInDineIn, availableInHomeDelivery, availableInTakeAway } = _restaurantList[i];

    //     if (distanceInMeter <= 200 && availableInDineIn) {
    //         isDineInAvailable = true;
    //         isTakeAwayAvailable = false;
    //         isDeliveryAvailable = false;
    //         selectedRestaurantObj = _restaurantList[i];
    //         break;
    //     } else if (availableInTakeAway) {
    //         isDineInAvailable = false;
    //         isDeliveryAvailable = false;
    //         isTakeAwayAvailable = true;
    //         selectedRestaurantObj = _restaurantList[i];
    //         // break;
    //     } else if (availableInHomeDelivery) {
    //         isDineInAvailable = false;
    //         isTakeAwayAvailable = false;
    //         isDeliveryAvailable = true;
    //         selectedRestaurantObj = _restaurantList[i];
    //         break;
    //     }
    // }

    const selectedRestaurantDetails = {
        restaurantId: selectedRestaurantObj.restaurantUuid,
        restaurantName: selectedRestaurantObj.title,
        restaurantRecordId: selectedRestaurantObj.recordId,
    };
    dispatchUtility({
        type: SET_RESTAURANT_ID,
        payload: selectedRestaurantDetails,
    });
    // if (isDineInAvailable) {
    //     setOrderType(dispatchUtility, DINE_IN);
    // } else if (isDeliveryAvailable) {
    //     setOrderType(dispatchUtility, HOME_DELIVERY);
    // } else if (isTakeAwayAvailable) {
    //     setOrderType(dispatchUtility, TAKE_AWAY);
    // } else {
    //     // Default
    //     setOrderType(dispatchUtility, HOME_DELIVERY);
    // }
};

export const handleGoBack = (location, navigate) => {
    if (location.key === "default" || location.pathname === '/offers') {
        navigate("/");
    } else {
        navigate(-1);
    }
};

export const getRewardPointAndWalletBalance = () => {
    return new Promise((resolve, reject) => {
        let rUrl = Get_Reward_Point_And_Wallet_Balance;
        callGetApi(
            rUrl,
            {},
            (response) => {
                if (response.errorCode === NO_ERROR) {
                    resolve(response.responsePacket);
                } else {
                    InformationAlert({ message: response.message });
                    reject(response.message);
                }
            },
            (error) => {
                const serverMessage = error.response?.data?.message;
                const errorMessage = error.message;
                reject(serverMessage ? serverMessage : errorMessage);
            }
        );
    });
};

export const completePostPaidOrder = (tempRequestObj) => {
    const { orderRefId, orderTotal, orderDetail, handleNavigation, txnId } = tempRequestObj;
    const rObj = {
        paidByWallet: orderTotal,
    };

    let rUrl = Post_Complete_Post_PaidOrder.replaceAll("{orderRefId}", orderRefId);
    callPostApi(rUrl, rObj, {}, (placeOrderRes) => {
        if (placeOrderRes.errorCode === NO_ERROR) {
            // handleSetLastPaymentMode()
            // bill is settled - the table is no longer ours
            clearDineInSession();
            InformationAlert({ title: ORDER_PLACED, message: placeOrderRes.message });
            handleNavigation();
            //   clevertapEvents.pushChargedEvent(orderDetails, lastPaymentModeObj.lastPaymentMode)
            AirBridgeUtilities.orderCompletedEvent(orderDetail, txnId);
        } else {
            InformationAlert({ message: placeOrderRes.message });
        }
    });
};

export const Upcoming_Restaurants = [
    // "Amritsar",
    // "Phagwara",
    // "Amayra Emporio, Kharar Highway",
    // "Agra",
    "Noida",
    //   "Sri Ganganagar",
    //   "Sangrur",
    // "Meerut",
    // "Mullanpur (Ludhiana)",
    // "Bathinda",
    "Nawanshahr",
    // "Mussoorie",
    "Haldwani",
    // "Ropar",
    "Behram, Phagwara-Nawashar Highway",
    // "London Street, Morinda",
    "Faridabad",
    "Anantara Karvan, Ropar-Manali Highway",
    "Downtown, Phase 8, Mohali",
    "Bharatmala Express Highway, Patra",
    // "Patiala",
    "West Villa, Bharatmala Express Highway, Dinanagar",
    "Moga",
    "Firozpur",
    // "Chd-Ludhiana Road",
    // "Kharar-Ropar Road",
];

// export const getDefaultLocation = () => {
//     const userAddress = Storage.getParsedValueFromStorage("selectedUserAddress");
//     if (userAddress) {
//         return userAddress;
//     } else {
//         const address = {
//             addressLine1: "",
//             addressLine2: "",
//             addressLine3: "",
//             addressType: "",
//             latitude: 0,
//             longitude: 0,
//             recordId: null,
//         };

//         address.addressLine1 = "NH 21, Chandigarh Kharar Road, Sec 118, SAS Nagar, Mohali";
//         address.latitude = 30.7374;
//         address.longitude = 76.6762;

//         return address;
//     }
// };

export const getLatLng = () => {
    return new Promise((resolve, reject) => {
        const getCurrentLocation = async () => {
            if (!navigator.geolocation) {
                reject(new Error("Geolocation is not supported by your browser"));
                return;
            }

            try {
                const permissionStatus = await navigator.permissions.query({ name: "geolocation" });
                if (permissionStatus.state === "denied") {
                    reject(new Error("Location permission is denied"));
                    return;
                }
            } catch (_) {
                // navigator.permissions.query not supported (e.g. Safari) — proceed with geolocation request
            }

            const address = {
                addressLine1: "",
                addressLine2: "",
                addressLine3: "",
                addressType: "",
                latitude: 0,
                longitude: 0,
                recordId: null,
                consent: false,
            };

            const locationPermissionOptions = {
                // enableHighAccuracy: true,
                timeout: 100000,
                maximumAge: 0,
            };

            const onSuccess = (position) => {
                address.latitude = position.coords.latitude;
                address.longitude = position.coords.longitude;
                const apiKey = process.env.REACT_APP_GOOGLE_MAPS_KEY;
                axios
                    .post(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${position.coords.latitude},${position.coords.longitude}&key=${apiKey}`)
                    .then((response) => {
                        let formattedAddress = response.data.results[0].formatted_address;
                        let removedWord = formattedAddress.split(",")[0];
                        const finalAddress = formattedAddress.replace(removedWord + ",", "");
                        address.addressLine1 = finalAddress;
                        address.consent = true;
                        resolve(address);
                    })
                    .catch((error) => {
                        reject(new Error("Failed to fetch address from coordinates"));
                    });
            };

            const onError = (error) => {
                reject(error);
            };

            navigator.geolocation.getCurrentPosition(onSuccess, onError, locationPermissionOptions);
        };

        getCurrentLocation();
    });
};

export const getFormattedDescription = (description = "", showIndex = false) => {
    if (description) {
        let message = "";
        if (showIndex) {
            message = description.split(/\r\n\r\n|\r\n|\n/);
        } else {
            message = description.split("\r\n\r\n");
        }
        const newMessage = (
            <ol className="terms-list">
                {message.map((term, i) => {
                    const index = i + 1;
                    let content = "";
                    if (showIndex) {
                        content = term.replace(/^\d+\.\s*/, "");
                    } else {
                        content = term.replaceAll("\r\n", "<br/>");
                    }

                    return (
                        <Fragment key={i}>
                            <li className="d-flex my-2">
                                {showIndex && <div className="term-number">{index}.</div>}
                                <div className="term-content" dangerouslySetInnerHTML={{ __html: content }}></div>
                            </li>
                            {/* {!showIndex && <br />} */}
                        </Fragment>
                    );
                })}
            </ol>
        );
        return newMessage;
    }
    return description;
};
